

import Slider from "react-slick";
import React from 'react';

export default function HomeLogos() {
  const logos = [
    { image: "/assets/images/new-client-logo1.webp", title: "Brand 1" },
    { image: "/assets/images/new-client-logo2.webp", title: "Brand 2" },
    { image: "/assets/images/new-client-logo3.webp", title: "Brand 3" },
    { image: "/assets/images/new-client-logo4.webp", title: "Brand 4" },
    { image: "/assets/images/new-client-logo5.webp", title: "Brand 5" },
    { image: "/assets/images/new-client-logo6.webp", title: "Brand 6" },
    { image: "/assets/images/new-client-logo7.webp", title: "Brand 7" },
    { image: "/assets/images/new-client-logo3.webp", title: "Brand 3" },
    { image: "/assets/images/new-client-logo4.webp", title: "Brand 4" },
    { image: "/assets/images/new-client-logo5.webp", title: "Brand 5" },

  ];

  const settingslogos = {
    dots: false,
    slidesToShow: 8,
    infinite: true,
    autoplay: true,
    slidesToScroll: 1,
     pauseOnHover: true,
    arrows: false,
    cssEase: "linear",
    autoplaySpeed: 0,
    initialSlide: 0,
    speed: 4000,
    responsive: [

  {
        breakpoint: 1150,
        settings: {
          slidesToShow: 5,
        },
      },

      {
        breakpoint: 991,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <>
     <section className="home-patner">
      <Slider {...settingslogos} className="home-brand-slider">
        {logos.map((logo, index) => (
          <div className="homepartner-box" key={index}>
            <div className="partner-inner">
              <img src={logo.image} alt={logo.title} className="img-responsive" loading="lazy" />
            </div>
          </div>
        ))}
      </Slider>
    </section>
    </>
   
  );
}
